import React, { createContext, useContext, useEffect, useState } from 'react';
import AuthContext from './AuthProvider';

const FeatureFlagContext = createContext({ flags: {}, ready: false });
const EMAIL = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/;

// Fetches every flag once per page load and shares it, so components using
// useFeatureFlag don't each hit /api/feature-flag. Refetches when the signed-in
// email arrives, because member_pricing targeting depends on that email.
export const FeatureFlagProvider = ({ children }) => {
  const auth = useContext(AuthContext);
  const userId = auth?.state?.email?.trim().toLowerCase() || '';
  const [state, setState] = useState({ flags: {}, ready: false });

  useEffect(() => {
    let cancelled = false;
    const params = new URLSearchParams();
    if (EMAIL.test(userId)) params.set('userId', userId);
    const query = params.toString();
    fetch(query ? `/api/feature-flag?${query}` : '/api/feature-flag')
      .then(response => (response.ok ? response.json() : { flags: {} }))
      .then(body => {
        if (!cancelled) setState({ flags: body.flags || {}, ready: true });
      })
      .catch(() => {
        if (!cancelled) setState({ flags: {}, ready: true });
      });
    return () => {
      cancelled = true;
    };
  }, [userId]);

  return <FeatureFlagContext.Provider value={state}>{children}</FeatureFlagContext.Provider>;
};

export default FeatureFlagContext;
